import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import InstallPWABanner from "./InstallPWABanner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#FAFAFA]">
      <InstallPWABanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
